// Oval Sticker Customizer - CORRECTED: Proper Aspect Ratios & No Safe Zone Clipping
// Image extends to FULL oval edge, safe zone is VISUAL GUIDE ONLY

(function() {
  'use strict';

  // EXACT aspect ratio configurations - no rounding
  const ASPECT_RATIOS = {
    '3x2': { 
      width: 450, 
      height: 300,
      exportWidth: 3600, 
      exportHeight: 2400, 
      physicalWidth: 3, 
      physicalHeight: 2 
    },
    '4x2': { 
      width: 450, 
      height: 225,
      exportWidth: 3600, 
      exportHeight: 1800, 
      physicalWidth: 4, 
      physicalHeight: 2 
    },
    '5x3': { 
      width: 450, 
      height: 270,
      exportWidth: 3600, 
      exportHeight: 2160, 
      physicalWidth: 5, 
      physicalHeight: 3 
    },
    '6x4': { 
      width: 450, 
      height: 300,
      exportWidth: 3600, 
      exportHeight: 2400, 
      physicalWidth: 6, 
      physicalHeight: 4 
    }
  };

  const SAFE_ZONE_MARGIN = 0.07;

  const state = {
    uploadedImage: null,
    uploadedImageUrl: null,
    cloudinaryUrl: null,
    canvas: null,
    ctx: null,
    canvasWidth: 450,
    canvasHeight: 300,
    physicalWidth: 3,
    physicalHeight: 2,
    safeZoneRadiusX: 0,
    safeZoneRadiusY: 0,
    imagePosition: { x: 225, y: 150 },
    imageScale: 1,
    imageRotation: 0,
    brightness: 100,
    contrast: 100,
    saturation: 100,
    flipHorizontal: false,
    flipVertical: false,
    backgroundColor: '#FFFFFF',
    textElements: [],
    shapeElements: [],
    selectedTextColor: '#000000',
    selectedFont: 'Roboto',
    fontSize: 32,
    letterSpacing: 0,
    lineHeight: 1.2,
    textOutline: false,
    textGradient: false,
    isDragging: false,
    isResizing: false,
    selectedElement: null,
    dragStart: { x: 0, y: 0 },
    dragOffset: { x: 0, y: 0 },
    resizeHandle: null,
    initialSize: 0,
    initialDistance: 0,
    currentTextInput: '',
    imageLayer: 1,
    productData: {
      quantity: '',
      size: '',
      price: '',
      title: '',
      variantId: ''
    },
    exportCanvas: null,
    exportCtx: null,
    exportWidth: 3600,
    exportHeight: 2400
  };

  document.addEventListener('DOMContentLoaded', function() {
    initializeCustomizer();
  });

  function initializeCustomizer() {
    state.canvas = document.getElementById('designCanvas');
    if (!state.canvas) {
      console.error('Canvas not found');
      return;
    }
    state.ctx = state.canvas.getContext('2d');

    state.exportCanvas = document.createElement('canvas');
    state.exportCtx = state.exportCanvas.getContext('2d');

    loadProductData();
    updateCanvasDimensions();
    alignSliders();
    setupTabNavigation();
    setupUpload();
    setupImageControls();
    setupTextControls();
    setupElementControls();
    setupBackgroundControls();
    setupSaveButton();
    setupResetButton();
    setupCanvasInteraction();
    setupKeyboardControls();

    renderCanvas();
  }

  function loadProductData() {
    const urlParams = new URLSearchParams(window.location.search);
    state.productData.quantity = urlParams.get('quantity') || '';
    
    let sizeParam = urlParams.get('size') || '3x2';
    sizeParam = sizeParam.replace(/"/g, '').replace(/×/g, 'x').replace(/\s+/g, '').toLowerCase();
    
    state.productData.size = sizeParam;
    state.productData.price = urlParams.get('price') || '';
    state.productData.title = urlParams.get('title') || 'Oval Stickers';
    state.productData.variantId = urlParams.get('variant') || '';
    
    console.log('Product size parameter:', sizeParam);
    
    if (!state.productData.variantId) {
      tryToFindVariant();
    }

    const productInfo = document.getElementById('productInfo');
    if (productInfo && state.productData.quantity && state.productData.size && state.productData.price) {
      const formattedSize = state.productData.size.replace('x', '"x') + '"';
      productInfo.textContent = `${state.productData.quantity} ${state.productData.title} • ${formattedSize} • $${state.productData.price}`;
    } else if (productInfo) {
      productInfo.textContent = 'Oval Sticker Customizer';
    }
  }

  function updateCanvasDimensions() {
    const sizeKey = state.productData.size || '3x2';
    const config = ASPECT_RATIOS[sizeKey] || ASPECT_RATIOS['3x2'];
    
    state.canvasWidth = config.width;
    state.canvasHeight = config.height;
    state.physicalWidth = config.physicalWidth;
    state.physicalHeight = config.physicalHeight;
    state.exportWidth = config.exportWidth;
    state.exportHeight = config.exportHeight;

    state.canvas.width = state.canvasWidth;
    state.canvas.height = state.canvasHeight;
    state.canvas.style.width = state.canvasWidth + 'px';
    state.canvas.style.height = state.canvasHeight + 'px';
    
    if (window.innerWidth <= 768) {
      const previewOval = document.getElementById('previewOval');
      if (previewOval) {
        const maxWidth = window.innerWidth * 0.85;
        const maxHeight = window.innerHeight - 280;
        const aspectRatio = state.canvasHeight / state.canvasWidth;
        
        let displayWidth = Math.min(state.canvasWidth, maxWidth);
        let displayHeight = displayWidth * aspectRatio;
        
        if (displayHeight > maxHeight) {
          displayHeight = maxHeight;
          displayWidth = displayHeight / aspectRatio;
        }
        
        previewOval.style.width = displayWidth + 'px';
        previewOval.style.height = displayHeight + 'px';
      }
    }
    
    state.exportCanvas.width = state.exportWidth;
    state.exportCanvas.height = state.exportHeight;

    const VISUAL_MARGIN_PX = 11;
    state.safeZoneRadiusX = (state.canvasWidth / 2) - VISUAL_MARGIN_PX;
    state.safeZoneRadiusY = (state.canvasHeight / 2) - VISUAL_MARGIN_PX;

    state.imagePosition = { 
      x: state.canvasWidth / 2, 
      y: state.canvasHeight / 2 
    };

    console.log(`Canvas configured: ${state.canvasWidth}x${state.canvasHeight}px (${state.physicalWidth}:${state.physicalHeight} ratio)`);
    console.log(`Actual ratio: ${(state.canvasWidth/state.canvasHeight).toFixed(3)}, Expected: ${(state.physicalWidth/state.physicalHeight).toFixed(3)}`);
    console.log(`Safe zone radii: ${state.safeZoneRadiusX.toFixed(1)}px x ${state.safeZoneRadiusY.toFixed(1)}px`);
  }

  function tryToFindVariant() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantInput = productForm.querySelector('select[name="id"], input[name="id"]');
      if (variantInput && variantInput.value) {
        state.productData.variantId = variantInput.value;
        return;
      }
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = urlParams.get('return_url');
    if (returnUrl) {
      const match = returnUrl.match(/variant=(\d+)/);
      if (match && match[1]) {
        state.productData.variantId = match[1];
        return;
      }
    }
  }

  function setupKeyboardControls() {
    document.addEventListener('keydown', function(e) {
      const textInput = document.getElementById('textInput');
      const isTypingInTextBox = textInput && document.activeElement === textInput;
      
      if ((e.key === 'Delete' || e.key === 'Backspace') && state.selectedElement && !isTypingInTextBox) {
        e.preventDefault();
        deleteSelectedElement();
      }
    });
  }

  function alignSliders() {
    const fontSizeSlider = document.getElementById('fontSizeSlider');
    const letterSpacingSlider = document.getElementById('letterSpacingSlider');
    const lineHeightSlider = document.getElementById('lineHeightSlider');

    if (fontSizeSlider) {
      fontSizeSlider.min = 12;
      fontSizeSlider.max = 112;
      fontSizeSlider.value = 32;
    }

    if (letterSpacingSlider) {
      letterSpacingSlider.min = -10;
      letterSpacingSlider.max = 40;
      letterSpacingSlider.value = 0;
    }

    if (lineHeightSlider) {
      lineHeightSlider.min = 0.8;
      lineHeightSlider.max = 2.8;
      lineHeightSlider.step = 0.1;
      lineHeightSlider.value = 1.2;
    }
  }

  function setupTabNavigation() {
    const sidebarIcons = document.querySelectorAll('.sidebar-icon');
    sidebarIcons.forEach(icon => {
      icon.addEventListener('click', function() {
        const tab = this.getAttribute('data-tab');
        sidebarIcons.forEach(i => i.classList.remove('active'));
        this.classList.add('active');
        const panels = document.querySelectorAll('.panel-content');
        panels.forEach(panel => panel.classList.remove('active'));
        const targetPanel = document.querySelector(`[data-content="${tab}"]`);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      });
    });
  }

  function setupUpload() {
    const uploadArea = document.getElementById('uploadArea');
    const fileInput = document.getElementById('fileInput');
    const removeImageBtn = document.getElementById('removeImageBtn');

    if (uploadArea && fileInput) {
      uploadArea.addEventListener('click', () => fileInput.click());
      fileInput.addEventListener('change', function(e) {
        if (e.target.files && e.target.files[0]) {
          handleFileUpload(e.target.files[0]);
        }
      });

      uploadArea.addEventListener('dragover', function(e) {
        e.preventDefault();
        this.classList.add('dragging');
      });

      uploadArea.addEventListener('dragleave', function(e) {
        e.preventDefault();
        this.classList.remove('dragging');
      });

      uploadArea.addEventListener('drop', function(e) {
        e.preventDefault();
        this.classList.remove('dragging');
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          handleFileUpload(e.dataTransfer.files[0]);
        }
      });
    }

    if (removeImageBtn) {
      removeImageBtn.addEventListener('click', function() {
        state.uploadedImage = null;
        state.uploadedImageUrl = null;
        state.cloudinaryUrl = null;
        state.selectedElement = null;
        state.imageScale = 1;
        state.imageLayer = 1;
        state.imagePosition = { x: state.canvasWidth / 2, y: state.canvasHeight / 2 };
        state.imageRotation = 0;
        state.brightness = 100;
        state.contrast = 100;
        state.saturation = 100;
        state.flipHorizontal = false;
        state.flipVertical = false;
        
        document.getElementById('uploadedImageInfo').style.display = 'none';
        
        const fileInput = document.getElementById('fileInput');
        if (fileInput) fileInput.value = '';
        
        const zoomSlider = document.getElementById('zoomSlider');
        const zoomValue = document.getElementById('zoomValue');
        if (zoomSlider) zoomSlider.value = 100;
        if (zoomValue) zoomValue.textContent = '100%';
        
        document.getElementById('rotationSlider').value = 0;
        document.getElementById('rotationValue').textContent = '0°';
        document.getElementById('brightnessSlider').value = 100;
        document.getElementById('brightnessValue').textContent = '100%';
        document.getElementById('contrastSlider').value = 100;
        document.getElementById('contrastValue').textContent = '100%';
        document.getElementById('saturationSlider').value = 100;
        document.getElementById('saturationValue').textContent = '100%';
        
        renderCanvas();
      });
    }
  }

  function handleFileUpload(file) {
    if (!file.type.match('image.*')) {
      showMessage('Please upload an image file', 'error');
      return;
    }

    if (file.size > 50 * 1024 * 1024) {
      showMessage('File size must be under 50MB', 'error');
      return;
    }

    showMessage('Uploading image...', 'info');
    uploadToCloudinary(file);
  }

  function uploadToCloudinary(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', window.cloudinaryConfig.uploadPreset);
    formData.append('folder', window.cloudinaryConfig.folder);

    fetch(`https://api.cloudinary.com/v1_1/${window.cloudinaryConfig.cloudName}/image/upload`, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.secure_url) {
        state.cloudinaryUrl = data.secure_url;
        loadImageToCanvas(data.secure_url);
        document.getElementById('uploadedImageInfo').style.display = 'block';
        document.getElementById('imageFileName').textContent = file.name;
        showMessage('Image uploaded successfully!', 'success');
      } else {
        showMessage('Upload failed. Please try again.', 'error');
      }
    })
    .catch(error => {
      console.error('Upload error:', error);
      showMessage('Upload failed. Please try again.', 'error');
    });
  }

  function loadImageToCanvas(url) {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function() {
      state.uploadedImage = img;
      state.uploadedImageUrl = url;
      state.imagePosition = { x: state.canvasWidth / 2, y: state.canvasHeight / 2 };
      
      const ovalRadiusX = state.canvasWidth / 2;
      const ovalRadiusY = state.canvasHeight / 2;
      
      const imgAspect = img.width / img.height;
      const ovalAspect = state.canvasWidth / state.canvasHeight;
      
      let fitScale;
      if (imgAspect > ovalAspect) {
        fitScale = (ovalRadiusX * 2) / img.width;
      } else {
        fitScale = (ovalRadiusY * 2) / img.height;
      }
      
      state.imageScale = fitScale;
      
      const zoomSlider = document.getElementById('zoomSlider');
      const zoomValue = document.getElementById('zoomValue');
      if (zoomSlider) zoomSlider.value = 100;
      if (zoomValue) zoomValue.textContent = '100%';
      
      state.imageLayer = Math.max(state.textElements.length, state.shapeElements.length) + 1;
      
      renderCanvas();
    };
    img.src = url;
  }

  function setupImageControls() {
    const zoomSlider = document.getElementById('zoomSlider');
    const zoomValue = document.getElementById('zoomValue');
    if (zoomSlider && zoomValue) {
      zoomSlider.min = 10;
      zoomSlider.max = 2000;
      zoomSlider.value = 100;
      
      zoomSlider.addEventListener('input', function() {
        const zoomPercent = this.value;
        
        if (state.uploadedImage) {
          const ovalRadiusX = state.canvasWidth / 2;
          const ovalRadiusY = state.canvasHeight / 2;
          
          const imgAspect = state.uploadedImage.width / state.uploadedImage.height;
          const ovalAspect = state.canvasWidth / state.canvasHeight;
          
          let baseFit;
          if (imgAspect > ovalAspect) {
            baseFit = (ovalRadiusX * 2) / state.uploadedImage.width;
          } else {
            baseFit = (ovalRadiusY * 2) / state.uploadedImage.height;
          }
          
          state.imageScale = baseFit * (zoomPercent / 100);
        }
        zoomValue.textContent = zoomPercent + '%';
        renderCanvas();
      });
    }

    const rotationSlider = document.getElementById('rotationSlider');
    const rotationValue = document.getElementById('rotationValue');
    if (rotationSlider && rotationValue) {
      rotationSlider.addEventListener('input', function() {
        state.imageRotation = this.value;
        rotationValue.textContent = this.value + '°';
        renderCanvas();
      });
    }

    const brightnessSlider = document.getElementById('brightnessSlider');
    const brightnessValue = document.getElementById('brightnessValue');
    if (brightnessSlider && brightnessValue) {
      brightnessSlider.addEventListener('input', function() {
        state.brightness = this.value;
        brightnessValue.textContent = this.value + '%';
        renderCanvas();
      });
    }

    const contrastSlider = document.getElementById('contrastSlider');
    const contrastValue = document.getElementById('contrastValue');
    if (contrastSlider && contrastValue) {
      contrastSlider.addEventListener('input', function() {
        state.contrast = this.value;
        contrastValue.textContent = this.value + '%';
        renderCanvas();
      });
    }

    const saturationSlider = document.getElementById('saturationSlider');
    const saturationValue = document.getElementById('saturationValue');
    if (saturationSlider && saturationValue) {
      saturationSlider.addEventListener('input', function() {
        state.saturation = this.value;
        saturationValue.textContent = this.value + '%';
        renderCanvas();
      });
    }

    const flipHorizontalBtn = document.getElementById('flipHorizontalBtn');
    const flipVerticalBtn = document.getElementById('flipVerticalBtn');
    
    if (flipHorizontalBtn) {
      flipHorizontalBtn.addEventListener('click', function() {
        state.flipHorizontal = !state.flipHorizontal;
        renderCanvas();
      });
    }

    if (flipVerticalBtn) {
      flipVerticalBtn.addEventListener('click', function() {
        state.flipVertical = !state.flipVertical;
        renderCanvas();
      });
    }

    const removeBackgroundBtn = document.getElementById('removeBackgroundBtn');
    if (removeBackgroundBtn) {
      removeBackgroundBtn.addEventListener('click', function() {
        showMessage('Background removal feature coming soon!', 'info');
      });
    }

    const imageFrontBtn = document.getElementById('imageFrontBtn');
    const imageBackBtn = document.getElementById('imageBackBtn');
    
    if (imageFrontBtn) {
      imageFrontBtn.addEventListener('click', function() {
        if (!state.uploadedImage) {
          showMessage('Please upload an image first', 'info');
          return;
        }
        const maxLayer = Math.max(
          state.textElements.length > 0 ? Math.max(...state.textElements.map(t => t.layer || 0)) : 0,
          state.shapeElements.length > 0 ? Math.max(...state.shapeElements.map(s => s.layer || 0)) : 0
        );
        state.imageLayer = maxLayer + 1;
        renderCanvas();
        showMessage('Image moved to front', 'success');
      });
    }

    if (imageBackBtn) {
      imageBackBtn.addEventListener('click', function() {
        if (!state.uploadedImage) {
          showMessage('Please upload an image first', 'info');
          return;
        }
        state.imageLayer = 0;
        renderCanvas();
        showMessage('Image moved to back', 'success');
      });
    }
  }

  function setupTextControls() {
    const textInput = document.getElementById('textInput');
    const addTextBtn = document.getElementById('addTextBtn');
    
    if (addTextBtn) {
      addTextBtn.style.display = 'none';
    }
    
    if (textInput) {
      textInput.addEventListener('input', function() {
        state.currentTextInput = this.value;
        
        if (state.currentTextInput && state.textElements.length === 0) {
          const highestLayer = 1000;
          const textElement = {
            text: state.currentTextInput,
            x: state.canvasWidth / 2,
            y: state.canvasHeight / 2,
            font: state.selectedFont,
            size: state.fontSize,
            color: state.selectedTextColor,
            letterSpacing: state.letterSpacing,
            lineHeight: state.lineHeight,
            outline: state.textOutline,
            gradient: state.textGradient,
            width: 100,
            height: 50,
            layer: highestLayer
          };
          state.textElements.push(textElement);
          state.selectedElement = { type: 'text', index: 0 };
        } else if (state.selectedElement && state.selectedElement.type === 'text') {
          state.textElements[state.selectedElement.index].text = state.currentTextInput;
        }
        
        renderCanvas();
      });

      textInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          const cursorPos = this.selectionStart;
          const textBefore = this.value.substring(0, cursorPos);
          const textAfter = this.value.substring(cursorPos);
          this.value = textBefore + '\n' + textAfter;
          this.selectionStart = this.selectionEnd = cursorPos + 1;
          
          const event = new Event('input', { bubbles: true });
          this.dispatchEvent(event);
        }
      });
    }

    const fontSelected = document.getElementById('fontSelected');
    const fontOptions = document.getElementById('fontOptions');
    
    if (fontSelected && fontOptions) {
      fontSelected.addEventListener('click', function() {
        fontOptions.classList.toggle('open');
        fontSelected.classList.toggle('open');
      });

      const fontOptionItems = fontOptions.querySelectorAll('.font-option');
      fontOptionItems.forEach(option => {
        option.addEventListener('click', function() {
          fontOptionItems.forEach(o => o.classList.remove('selected'));
          this.classList.add('selected');
          
          const fontName = this.getAttribute('data-font');
          const fontFamily = this.style.fontFamily;
          
          state.selectedFont = fontName;
          fontSelected.textContent = fontName;
          fontSelected.style.fontFamily = fontFamily;
          
          fontOptions.classList.remove('open');
          fontSelected.classList.remove('open');
          
          if (state.selectedElement && state.selectedElement.type === 'text') {
            state.textElements[state.selectedElement.index].font = fontName;
          }
          
          renderCanvas();
        });
      });

      document.addEventListener('click', function(e) {
        if (!e.target.closest('.font-dropdown-custom')) {
          fontOptions.classList.remove('open');
          fontSelected.classList.remove('open');
        }
      });
    }

    const fontSizeSlider = document.getElementById('fontSizeSlider');
    const fontSizeValue = document.getElementById('fontSizeValue');
    if (fontSizeSlider && fontSizeValue) {
      fontSizeSlider.addEventListener('input', function() {
        state.fontSize = parseInt(this.value);
        fontSizeValue.textContent = this.value + 'px';
        
        if (state.selectedElement && state.selectedElement.type === 'text') {
          state.textElements[state.selectedElement.index].size = state.fontSize;
        }
        
        renderCanvas();
      });
    }

    const letterSpacingSlider = document.getElementById('letterSpacingSlider');
    const letterSpacingValue = document.getElementById('letterSpacingValue');
    if (letterSpacingSlider && letterSpacingValue) {
      letterSpacingSlider.addEventListener('input', function() {
        state.letterSpacing = parseInt(this.value);
        letterSpacingValue.textContent = this.value + 'px';
        
        if (state.selectedElement && state.selectedElement.type === 'text') {
          state.textElements[state.selectedElement.index].letterSpacing = state.letterSpacing;
        }
        
        renderCanvas();
      });
    }

    const lineHeightSlider = document.getElementById('lineHeightSlider');
    const lineHeightValue = document.getElementById('lineHeightValue');
    if (lineHeightSlider && lineHeightValue) {
      lineHeightSlider.addEventListener('input', function() {
        state.lineHeight = parseFloat(this.value);
        lineHeightValue.textContent = this.value;
        
        if (state.selectedElement && state.selectedElement.type === 'text') {
          state.textElements[state.selectedElement.index].lineHeight = state.lineHeight;
        }
        
        renderCanvas();
      });
    }

    const textColorGrid = document.getElementById('textColorGrid');
    if (textColorGrid) {
      const colorSwatches = textColorGrid.querySelectorAll('.color-swatch');
      colorSwatches.forEach(swatch => {
        swatch.addEventListener('click', function() {
          colorSwatches.forEach(s => s.classList.remove('selected'));
          this.classList.add('selected');
          state.selectedTextColor = this.getAttribute('data-color');
          
          if (state.selectedElement && state.selectedElement.type === 'text') {
            state.textElements[state.selectedElement.index].color = state.selectedTextColor;
          }
          
          renderCanvas();
        });
      });
    }

    const textOutlineBtn = document.getElementById('textOutlineBtn');
    const textGradientBtn = document.getElementById('textGradientBtn');
    
    if (textOutlineBtn) {
      textOutlineBtn.addEventListener('click', function() {
        state.textOutline = !state.textOutline;
        this.style.opacity = state.textOutline ? '1' : '0.7';
        
        if (state.selectedElement && state.selectedElement.type === 'text') {
          state.textElements[state.selectedElement.index].outline = state.textOutline;
        }
        
        renderCanvas();
      });
    }

    if (textGradientBtn) {
      textGradientBtn.addEventListener('click', function() {
        state.textGradient = !state.textGradient;
        this.style.opacity = state.textGradient ? '1' : '0.7';
        
        if (state.selectedElement && state.selectedElement.type === 'text') {
          state.textElements[state.selectedElement.index].gradient = state.textGradient;
        }
        
        renderCanvas();
      });
    }

    const textFrontBtn = document.getElementById('textFrontBtn');
    const textBackBtn = document.getElementById('textBackBtn');
    
    if (textFrontBtn) {
      textFrontBtn.addEventListener('click', function() {
        if (!state.selectedElement || state.selectedElement.type !== 'text') {
          showMessage('Please select a text element first', 'info');
          return;
        }
        
        const text = state.textElements[state.selectedElement.index];
        const maxLayer = Math.max(
          state.imageLayer || 0,
          state.textElements.length > 0 ? Math.max(...state.textElements.map(t => t.layer || 0)) : 0,
          state.shapeElements.length > 0 ? Math.max(...state.shapeElements.map(s => s.layer || 0)) : 0
        );
        text.layer = maxLayer + 1;
        renderCanvas();
        showMessage('Text moved to front', 'success');
      });
    }

    if (textBackBtn) {
      textBackBtn.addEventListener('click', function() {
        if (!state.selectedElement || state.selectedElement.type !== 'text') {
          showMessage('Please select a text element first', 'info');
          return;
        }
        
        const text = state.textElements[state.selectedElement.index];
        text.layer = 0;
        renderCanvas();
        showMessage('Text moved to back', 'success');
      });
    }
  }

  function setupElementControls() {
    const elementItems = document.querySelectorAll('.element-item');
    
    elementItems.forEach(item => {
      item.addEventListener('click', function() {
        const elementType = this.getAttribute('data-element');
        addElementToCanvas(elementType);
      });
    });

    const bringToFrontBtn = document.getElementById('bringToFrontBtn');
    const sendToBackBtn = document.getElementById('sendToBackBtn');
    const clearElementsBtn = document.getElementById('clearElementsBtn');

    if (bringToFrontBtn) {
      bringToFrontBtn.addEventListener('click', function() {
        if (!state.selectedElement || state.selectedElement.type !== 'shape') {
          showMessage('Please select an element first', 'info');
          return;
        }

        const shape = state.shapeElements[state.selectedElement.index];
        const maxLayer = Math.max(
          state.imageLayer || 0,
          state.textElements.length > 0 ? Math.max(...state.textElements.map(t => t.layer || 0)) : 0,
          state.shapeElements.length > 0 ? Math.max(...state.shapeElements.map(s => s.layer || 0)) : 0
        );
        shape.layer = maxLayer + 1;
        renderCanvas();
        showMessage('Element moved to front', 'success');
      });
    }

    if (sendToBackBtn) {
      sendToBackBtn.addEventListener('click', function() {
        if (!state.selectedElement || state.selectedElement.type !== 'shape') {
          showMessage('Please select an element first', 'info');
          return;
        }

        const shape = state.shapeElements[state.selectedElement.index];
        shape.layer = 0;
        renderCanvas();
        showMessage('Element moved to back', 'success');
      });
    }

    if (clearElementsBtn) {
      clearElementsBtn.addEventListener('click', function() {
        state.shapeElements = [];
        state.selectedElement = null;
        renderCanvas();
        showMessage('All elements cleared', 'success');
      });
    }
  }

  function addElementToCanvas(type) {
    const maxLayer = Math.max(
      state.imageLayer || 0,
      state.textElements.length > 0 ? Math.max(...state.textElements.map(t => t.layer || 0)) : 0,
      state.shapeElements.length > 0 ? Math.max(...state.shapeElements.map(s => s.layer || 0)) : 0
    );
    
    const element = {
      type: type,
      x: state.canvasWidth / 2,
      y: state.canvasHeight / 2,
      size: 50,
      color: '#000000',
      rotation: 0,
      layer: maxLayer + 1
    };
    
    state.shapeElements.push(element);
    state.selectedElement = { type: 'shape', index: state.shapeElements.length - 1 };
    renderCanvas();
    showMessage('Element added to design', 'success');
  }

  function setupBackgroundControls() {
    const backgroundColorGrid = document.getElementById('backgroundColorGrid');
    const previewOval = document.getElementById('previewOval');
    const resetBackgroundBtn = document.getElementById('resetBackgroundBtn');

    if (backgroundColorGrid) {
      const colorSwatches = backgroundColorGrid.querySelectorAll('.color-swatch');
      colorSwatches.forEach(swatch => {
        swatch.addEventListener('click', function() {
          const color = this.getAttribute('data-color');
          if (color) {
            state.backgroundColor = color;
            if (previewOval) previewOval.style.backgroundColor = color;
            colorSwatches.forEach(s => s.classList.remove('selected'));
            this.classList.add('selected');
            renderCanvas();
          }
        });
      });
    }

    if (resetBackgroundBtn) {
      resetBackgroundBtn.addEventListener('click', function() {
        state.backgroundColor = '#FFFFFF';
        if (previewOval) previewOval.style.backgroundColor = '#FFFFFF';
        const whiteColorSwatch = backgroundColorGrid.querySelector('[data-color="#FFFFFF"]');
        if (whiteColorSwatch) {
          const allSwatches = backgroundColorGrid.querySelectorAll('.color-swatch');
          allSwatches.forEach(s => s.classList.remove('selected'));
          whiteColorSwatch.classList.add('selected');
        }
        renderCanvas();
      });
    }
  }

  function setupCanvasInteraction() {
    const canvas = state.canvas;
    
    canvas.addEventListener('mousedown', handleMouseDown);
    canvas.addEventListener('mousemove', handleMouseMove);
    canvas.addEventListener('mouseup', handleMouseUp);
    canvas.addEventListener('mouseleave', handleMouseUp);

    canvas.addEventListener('touchstart', handleTouchStart);
    canvas.addEventListener('touchmove', handleTouchMove);
    canvas.addEventListener('touchend', handleMouseUp);
  }

  function handleMouseDown(e) {
    const rect = state.canvas.getBoundingClientRect();
    const scaleX = state.canvas.width / rect.width;
    const scaleY = state.canvas.height / rect.height;
    const x = (e.clientX - rect.left) * scaleX;
    const y = (e.clientY - rect.top) * scaleY;
    
    if (state.selectedElement) {
      const deletePos = getDeleteButtonPosition(state.selectedElement);
      if (deletePos && isPointInCircle(x, y, deletePos.x, deletePos.y, 12)) {
        deleteSelectedElement();
        return;
      }
    }
    
    if (state.selectedElement) {
      const handles = getResizeHandles(state.selectedElement);
      for (let i = 0; i < handles.length; i++) {
        if (isPointInCircle(x, y, handles[i].x, handles[i].y, 8)) {
          state.isResizing = true;
          state.resizeHandle = i;
          state.dragStart = { x, y };
          
          if (state.selectedElement.type === 'text') {
            state.initialSize = state.textElements[state.selectedElement.index].size;
            const text = state.textElements[state.selectedElement.index];
            state.initialDistance = Math.sqrt(Math.pow(x - text.x, 2) + Math.pow(y - text.y, 2));
          } else if (state.selectedElement.type === 'shape') {
            state.initialSize = state.shapeElements[state.selectedElement.index].size;
            const shape = state.shapeElements[state.selectedElement.index];
            state.initialDistance = Math.sqrt(Math.pow(x - shape.x, 2) + Math.pow(y - shape.y, 2));
          } else if (state.selectedElement.type === 'image') {
            state.initialSize = state.imageScale;
            state.initialDistance = Math.sqrt(Math.pow(x - state.imagePosition.x, 2) + Math.pow(y - state.imagePosition.y, 2));
          }
          
          return;
        }
      }
    }
    
    for (let i = state.textElements.length - 1; i >= 0; i--) {
      const text = state.textElements[i];
      if (isPointInRect(x, y, text.x - text.width/2, text.y - text.height/2, text.width, text.height)) {
        state.selectedElement = { type: 'text', index: i };
        state.isDragging = true;
        state.dragStart = { x, y };
        state.dragOffset = { x: x - text.x, y: y - text.y };
        updateTextControls(text);
        renderCanvas();
        return;
      }
    }
    
    for (let i = state.shapeElements.length - 1; i >= 0; i--) {
      const shape = state.shapeElements[i];
      if (isPointInCircle(x, y, shape.x, shape.y, shape.size/2)) {
        state.selectedElement = { type: 'shape', index: i };
        state.isDragging = true;
        state.dragStart = { x, y };
        state.dragOffset = { x: x - shape.x, y: y - shape.y };
        renderCanvas();
        return;
      }
    }
    
    if (state.uploadedImage) {
      const scaledWidth = state.uploadedImage.width * state.imageScale;
      const scaledHeight = state.uploadedImage.height * state.imageScale;
      if (isPointInRect(x, y, state.imagePosition.x - scaledWidth/2, state.imagePosition.y - scaledHeight/2, scaledWidth, scaledHeight)) {
        state.selectedElement = { type: 'image', index: 0 };
        state.isDragging = true;
        state.dragStart = { x, y };
        state.dragOffset = { x: x - state.imagePosition.x, y: y - state.imagePosition.y };
        renderCanvas();
        return;
      }
    }
    
    state.selectedElement = null;
    renderCanvas();
  }

  function handleMouseMove(e) {
    const rect = state.canvas.getBoundingClientRect();
    const scaleX = state.canvas.width / rect.width;
    const scaleY = state.canvas.height / rect.height;
    const x = (e.clientX - rect.left) * scaleX;
    const y = (e.clientY - rect.top) * scaleY;
    
    if (state.isResizing && state.selectedElement) {
      handleResize(x, y);
    } else if (state.isDragging && state.selectedElement) {
      handleDrag(x, y);
    }
  }

  function handleMouseUp() {
    state.isDragging = false;
    state.isResizing = false;
    state.resizeHandle = null;
  }

  function handleTouchStart(e) {
    if (e.touches.length > 0) {
      const touch = e.touches[0];
      const mouseEvent = new MouseEvent('mousedown', {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      handleMouseDown(mouseEvent);
      e.preventDefault();
    }
  }

  function handleTouchMove(e) {
    if (e.touches.length > 0) {
      const touch = e.touches[0];
      const mouseEvent = new MouseEvent('mousemove', {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      handleMouseMove(mouseEvent);
      e.preventDefault();
    }
  }

  function handleDrag(x, y) {
    const newX = x - state.dragOffset.x;
    const newY = y - state.dragOffset.y;
    
    if (state.selectedElement.type === 'text') {
      state.textElements[state.selectedElement.index].x = newX;
      state.textElements[state.selectedElement.index].y = newY;
    } else if (state.selectedElement.type === 'shape') {
      state.shapeElements[state.selectedElement.index].x = newX;
      state.shapeElements[state.selectedElement.index].y = newY;
    } else if (state.selectedElement.type === 'image') {
      state.imagePosition.x = newX;
      state.imagePosition.y = newY;
    }
    
    renderCanvas();
  }

  function handleResize(x, y) {
    let centerX, centerY;
    
    if (state.selectedElement.type === 'text') {
      const text = state.textElements[state.selectedElement.index];
      centerX = text.x;
      centerY = text.y;
    } else if (state.selectedElement.type === 'shape') {
      const shape = state.shapeElements[state.selectedElement.index];
      centerX = shape.x;
      centerY = shape.y;
    } else if (state.selectedElement.type === 'image') {
      centerX = state.imagePosition.x;
      centerY = state.imagePosition.y;
    }
    
    const currentDistance = Math.sqrt(Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2));
    const distanceRatio = currentDistance / state.initialDistance;
    
    if (state.selectedElement.type === 'text') {
      const text = state.textElements[state.selectedElement.index];
      text.size = Math.max(12, state.initialSize * distanceRatio);
    } else if (state.selectedElement.type === 'shape') {
      const shape = state.shapeElements[state.selectedElement.index];
      shape.size = Math.max(20, state.initialSize * distanceRatio);
    } else if (state.selectedElement.type === 'image') {
      const newScale = Math.max(0.01, state.initialSize * distanceRatio);
      state.imageScale = newScale;
      
      if (state.uploadedImage) {
        const ovalRadiusX = state.canvasWidth / 2;
        const ovalRadiusY = state.canvasHeight / 2;
        
        const imgAspect = state.uploadedImage.width / state.uploadedImage.height;
        const ovalAspect = state.canvasWidth / state.canvasHeight;
        
        let baseFit;
        if (imgAspect > ovalAspect) {
          baseFit = (ovalRadiusX * 2) / state.uploadedImage.width;
        } else {
          baseFit = (ovalRadiusY * 2) / state.uploadedImage.height;
        }
        
        const zoomPercent = Math.round((newScale / baseFit) * 100);
        const zoomSlider = document.getElementById('zoomSlider');
        const zoomValue = document.getElementById('zoomValue');
        if (zoomSlider && zoomValue) {
          zoomSlider.value = Math.max(10, Math.min(2000, zoomPercent));
          zoomValue.textContent = Math.max(10, Math.min(2000, zoomPercent)) + '%';
        }
      }
    }
    
    renderCanvas();
  }

  function deleteSelectedElement() {
    if (!state.selectedElement) return;
    
    if (state.selectedElement.type === 'text') {
      state.textElements.splice(state.selectedElement.index, 1);
      document.getElementById('textInput').value = '';
      state.currentTextInput = '';
    } else if (state.selectedElement.type === 'shape') {
      state.shapeElements.splice(state.selectedElement.index, 1);
    } else if (state.selectedElement.type === 'image') {
      state.uploadedImage = null;
      state.uploadedImageUrl = null;
      state.cloudinaryUrl = null;
      state.imageScale = 1;
      state.imageLayer = 1;
      state.imagePosition = { x: state.canvasWidth / 2, y: state.canvasHeight / 2 };
      state.imageRotation = 0;
      state.brightness = 100;
      state.contrast = 100;
      state.saturation = 100;
      state.flipHorizontal = false;
      state.flipVertical = false;
      
      document.getElementById('uploadedImageInfo').style.display = 'none';
      
      const fileInput = document.getElementById('fileInput');
      if (fileInput) fileInput.value = '';
      
      const zoomSlider = document.getElementById('zoomSlider');
      const zoomValue = document.getElementById('zoomValue');
      if (zoomSlider) zoomSlider.value = 100;
      if (zoomValue) zoomValue.textContent = '100%';
    }
    
    state.selectedElement = null;
    renderCanvas();
    showMessage('Element deleted', 'success');
  }

  function updateTextControls(text) {
    const textInput = document.getElementById('textInput');
    const fontSelected = document.getElementById('fontSelected');
    const fontSizeSlider = document.getElementById('fontSizeSlider');
    const fontSizeValue = document.getElementById('fontSizeValue');
    const letterSpacingSlider = document.getElementById('letterSpacingSlider');
    const letterSpacingValue = document.getElementById('letterSpacingValue');
    const lineHeightSlider = document.getElementById('lineHeightSlider');
    const lineHeightValue = document.getElementById('lineHeightValue');
    
    if (textInput) textInput.value = text.text;
    if (fontSelected) fontSelected.textContent = text.font;
    if (fontSizeSlider) fontSizeSlider.value = text.size;
    if (fontSizeValue) fontSizeValue.textContent = text.size + 'px';
    if (letterSpacingSlider) letterSpacingSlider.value = text.letterSpacing;
    if (letterSpacingValue) letterSpacingValue.textContent = text.letterSpacing + 'px';
    if (lineHeightSlider) lineHeightSlider.value = text.lineHeight;
    if (lineHeightValue) lineHeightValue.textContent = text.lineHeight;
    
    state.currentTextInput = text.text;
    state.selectedFont = text.font;
    state.fontSize = text.size;
    state.letterSpacing = text.letterSpacing;
    state.lineHeight = text.lineHeight;
    state.selectedTextColor = text.color;
  }

  function isPointInRect(px, py, x, y, w, h) {
    return px >= x && px <= x + w && py >= y && py <= y + h;
  }

  function isPointInCircle(px, py, cx, cy, radius) {
    const dx = px - cx;
    const dy = py - cy;
    return dx * dx + dy * dy <= radius * radius;
  }

  function getResizeHandles(element) {
    if (!element) return [];
    
    if (element.type === 'text') {
      const text = state.textElements[element.index];
      const w = text.width;
      const h = text.height;
      const cx = text.x;
      const cy = text.y;
      return [
        { x: cx - w/2, y: cy - h/2 },
        { x: cx + w/2, y: cy - h/2 },
        { x: cx - w/2, y: cy + h/2 },
        { x: cx + w/2, y: cy + h/2 },
        { x: cx, y: cy - h/2 },
        { x: cx, y: cy + h/2 },
        { x: cx - w/2, y: cy },
        { x: cx + w/2, y: cy }
      ];
    } else if (element.type === 'shape') {
      const shape = state.shapeElements[element.index];
      const s = shape.size / 2;
      return [
        { x: shape.x - s, y: shape.y - s },
        { x: shape.x + s, y: shape.y - s },
        { x: shape.x - s, y: shape.y + s },
        { x: shape.x + s, y: shape.y + s },
        { x: shape.x, y: shape.y - s },
        { x: shape.x, y: shape.y + s },
        { x: shape.x - s, y: shape.y },
        { x: shape.x + s, y: shape.y }
      ];
    } else if (element.type === 'image' && state.uploadedImage) {
      const scaledWidth = state.uploadedImage.width * state.imageScale;
      const scaledHeight = state.uploadedImage.height * state.imageScale;
      const cx = state.imagePosition.x;
      const cy = state.imagePosition.y;
      return [
        { x: cx - scaledWidth/2, y: cy - scaledHeight/2 },
        { x: cx + scaledWidth/2, y: cy - scaledHeight/2 },
        { x: cx - scaledWidth/2, y: cy + scaledHeight/2 },
        { x: cx + scaledWidth/2, y: cy + scaledHeight/2 },
        { x: cx, y: cy - scaledHeight/2 },
        { x: cx, y: cy + scaledHeight/2 },
        { x: cx - scaledWidth/2, y: cy },
        { x: cx + scaledWidth/2, y: cy }
      ];
    }
    
    return [];
  }

  function getDeleteButtonPosition(element) {
    if (!element) return null;
    
    if (element.type === 'text') {
      const text = state.textElements[element.index];
      return { x: text.x + text.width/2, y: text.y - text.height/2 };
    } else if (element.type === 'shape') {
      const shape = state.shapeElements[element.index];
      return { x: shape.x + shape.size/2, y: shape.y - shape.size/2 };
    } else if (element.type === 'image' && state.uploadedImage) {
      const scaledWidth = state.uploadedImage.width * state.imageScale;
      const scaledHeight = state.uploadedImage.height * state.imageScale;
      return { x: state.imagePosition.x + scaledWidth/2, y: state.imagePosition.y - scaledHeight/2 };
    }
    
    return null;
  }

  function renderCanvas() {
    const ctx = state.ctx;
    const canvas = state.canvas;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.save();
    ctx.fillStyle = state.backgroundColor;
    ctx.beginPath();
    ctx.ellipse(state.canvasWidth/2, state.canvasHeight/2, state.canvasWidth/2, state.canvasHeight/2, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();

    const allElements = [];
    
    if (state.uploadedImage) {
      allElements.push({ type: 'image', layer: state.imageLayer || 1 });
    }
    
    state.textElements.forEach((text, index) => {
      allElements.push({ type: 'text', index: index, layer: text.layer || 0 });
    });
    
    state.shapeElements.forEach((shape, index) => {
      allElements.push({ type: 'shape', index: index, layer: shape.layer || 0 });
    });
    
    allElements.sort((a, b) => a.layer - b.layer);
    
    allElements.forEach(element => {
      if (element.type === 'image') {
        drawImage(ctx);
      } else if (element.type === 'text') {
        drawText(ctx, state.textElements[element.index]);
      } else if (element.type === 'shape') {
        drawElement(ctx, state.shapeElements[element.index]);
      }
    });

    if (state.renderingSafeZone !== false) {
      ctx.save();
      ctx.strokeStyle = '#FF0000';
      ctx.lineWidth = 2;
      ctx.setLineDash([8, 4]);
      ctx.beginPath();
      ctx.ellipse(state.canvasWidth/2, state.canvasHeight/2, state.safeZoneRadiusX, state.safeZoneRadiusY, 0, 0, Math.PI * 2);
      ctx.stroke();
      ctx.restore();
    }

    if (state.selectedElement) {
      drawSelectionUI(ctx, state.selectedElement);
    }
  }

  function drawImage(ctx) {
    if (!state.uploadedImage) return;
    
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(state.canvasWidth/2, state.canvasHeight/2, state.canvasWidth/2, state.canvasHeight/2, 0, 0, Math.PI * 2);
    ctx.clip();
    ctx.translate(state.imagePosition.x, state.imagePosition.y);
    ctx.rotate((state.imageRotation * Math.PI) / 180);
    if (state.flipHorizontal) ctx.scale(-1, 1);
    if (state.flipVertical) ctx.scale(1, -1);
    ctx.filter = `brightness(${state.brightness}%) contrast(${state.contrast}%) saturate(${state.saturation}%)`;
    const scaledWidth = state.uploadedImage.width * state.imageScale;
    const scaledHeight = state.uploadedImage.height * state.imageScale;
    ctx.drawImage(state.uploadedImage, -scaledWidth / 2, -scaledHeight / 2, scaledWidth, scaledHeight);
    ctx.restore();
  }

  function drawElement(ctx, element) {
    ctx.save();
    ctx.translate(element.x, element.y);
    ctx.rotate((element.rotation * Math.PI) / 180);
    ctx.fillStyle = element.color;
    
    const size = element.size;
    
    switch(element.type) {
      case 'star':
      case 'star-filled':
        drawStar(ctx, 0, 0, 5, size, size/2);
        break;
      case 'heart':
        drawHeart(ctx, 0, 0, size);
        break;
      case 'circle':
        ctx.beginPath();
        ctx.arc(0, 0, size/2, 0, Math.PI * 2);
        ctx.fill();
        break;
      case 'square':
        ctx.fillRect(-size/2, -size/2, size, size);
        break;
      case 'triangle':
        drawTriangle(ctx, 0, 0, size);
        break;
      case 'arrow':
        drawArrow(ctx, 0, 0, size);
        break;
      case 'diamond':
        drawDiamond(ctx, 0, 0, size);
        break;
      case 'flag':
        drawFlag(ctx, 0, 0, size);
        break;
    }
    
    ctx.restore();
  }

  function drawStar(ctx, cx, cy, spikes, outerRadius, innerRadius) {
    let rot = Math.PI / 2 * 3;
    let step = Math.PI / spikes;
    ctx.beginPath();
    ctx.moveTo(cx, cy - outerRadius);
    for (let i = 0; i < spikes; i++) {
      let x = cx + Math.cos(rot) * outerRadius;
      let y = cy + Math.sin(rot) * outerRadius;
      ctx.lineTo(x, y);
      rot += step;
      x = cx + Math.cos(rot) * innerRadius;
      y = cy + Math.sin(rot) * innerRadius;
      ctx.lineTo(x, y);
      rot += step;
    }
    ctx.lineTo(cx, cy - outerRadius);
    ctx.closePath();
    ctx.fill();
  }

  function drawHeart(ctx, x, y, size) {
    ctx.beginPath();
    const topCurveHeight = size * 0.3;
    ctx.moveTo(x, y + topCurveHeight);
    ctx.bezierCurveTo(x, y, x - size / 2, y, x - size / 2, y + topCurveHeight);
    ctx.bezierCurveTo(x - size / 2, y + (size + topCurveHeight) / 2, x, y + (size + topCurveHeight) / 2, x, y + size);
    ctx.bezierCurveTo(x, y + (size + topCurveHeight) / 2, x + size / 2, y + (size + topCurveHeight) / 2, x + size / 2, y + topCurveHeight);
    ctx.bezierCurveTo(x + size / 2, y, x, y, x, y + topCurveHeight);
    ctx.closePath();
    ctx.fill();
  }

  function drawTriangle(ctx, x, y, size) {
    ctx.beginPath();
    ctx.moveTo(x, y - size/2);
    ctx.lineTo(x + size/2, y + size/2);
    ctx.lineTo(x - size/2, y + size/2);
    ctx.closePath();
    ctx.fill();
  }

  function drawArrow(ctx, x, y, size) {
    ctx.beginPath();
    ctx.moveTo(x, y - size/2);
    ctx.lineTo(x + size/2, y);
    ctx.lineTo(x + size/4, y);
    ctx.lineTo(x + size/4, y + size/2);
    ctx.lineTo(x - size/4, y + size/2);
    ctx.lineTo(x - size/4, y);
    ctx.lineTo(x - size/2, y);
    ctx.closePath();
    ctx.fill();
  }

  function drawDiamond(ctx, x, y, size) {
    ctx.beginPath();
    ctx.moveTo(x, y - size/2);
    ctx.lineTo(x + size/2, y);
    ctx.lineTo(x, y + size/2);
    ctx.lineTo(x - size/2, y);
    ctx.closePath();
    ctx.fill();
  }

  function drawFlag(ctx, x, y, size) {
    ctx.fillRect(x - size/2, y - size/2, size * 0.15, size);
    ctx.beginPath();
    ctx.moveTo(x - size/2 + size * 0.15, y - size/2);
    ctx.lineTo(x + size/2, y - size/4);
    ctx.lineTo(x - size/2 + size * 0.15, y);
    ctx.closePath();
    ctx.fill();
  }

  function drawText(ctx, textElement) {
    ctx.save();
    
    const fontFamily = textElement.font || 'Roboto';
    ctx.font = `${textElement.size}px '${fontFamily}', sans-serif`;
    ctx.fillStyle = textElement.color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    const lines = textElement.text.split('\n');
    const lineHeightPx = textElement.size * textElement.lineHeight;
    const totalHeight = lines.length * lineHeightPx;
    const startY = textElement.y - totalHeight / 2 + lineHeightPx / 2;
    
    lines.forEach((line, index) => {
      const currentY = startY + (index * lineHeightPx);
      
      if (textElement.letterSpacing !== 0) {
        const letters = line.split('');
        let currentX = textElement.x - (ctx.measureText(line).width / 2);
        letters.forEach(letter => {
          ctx.fillText(letter, currentX, currentY);
          currentX += ctx.measureText(letter).width + textElement.letterSpacing;
        });
      } else {
        if (textElement.outline) {
          ctx.strokeStyle = '#FFFFFF';
          ctx.lineWidth = 3;
          ctx.strokeText(line, textElement.x, currentY);
        }
        
        if (textElement.gradient) {
          const gradient = ctx.createLinearGradient(textElement.x - 100, currentY, textElement.x + 100, currentY);
          gradient.addColorStop(0, textElement.color);
          gradient.addColorStop(1, '#FFFFFF');
          ctx.fillStyle = gradient;
        }
        
        ctx.fillText(line, textElement.x, currentY);
      }
    });
    
    const maxLineWidth = Math.max(...lines.map(line => ctx.measureText(line).width));
    textElement.width = maxLineWidth + 20;
    textElement.height = totalHeight + 20;
    
    ctx.restore();
  }

  function renderHighResCanvas(upscaledImage) {
    const ctx = state.exportCtx;
    const scaleX = state.exportWidth / state.canvasWidth;
    const scaleY = state.exportHeight / state.canvasHeight;

    ctx.clearRect(0, 0, state.exportWidth, state.exportHeight);
    
    ctx.save();
    ctx.fillStyle = state.backgroundColor;
    ctx.beginPath();
    ctx.ellipse(state.exportWidth/2, state.exportHeight/2, state.exportWidth/2, state.exportHeight/2, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();

    const allElements = [];
    if (state.uploadedImage) {
      allElements.push({ type: 'image', layer: state.imageLayer || 1 });
    }
    state.textElements.forEach((text, index) => {
      allElements.push({ type: 'text', index: index, layer: text.layer || 0 });
    });
    state.shapeElements.forEach((shape, index) => {
      allElements.push({ type: 'shape', index: index, layer: shape.layer || 0 });
    });
    allElements.sort((a, b) => a.layer - b.layer);
    
    allElements.forEach(element => {
      if (element.type === 'image') {
        drawImageHighRes(ctx, scaleX, scaleY, upscaledImage);
      } else if (element.type === 'text') {
        drawTextHighRes(ctx, state.textElements[element.index], scaleX, scaleY);
      } else if (element.type === 'shape') {
        drawElementHighRes(ctx, state.shapeElements[element.index], scaleX, scaleY);
      }
    });
  }

  function drawImageHighRes(ctx, scaleX, scaleY, upscaledImage) {
    const imgToDraw = upscaledImage || state.uploadedImage;
    if (!imgToDraw) return;
    
    let adjustedImageScale = state.imageScale;
    
    if (upscaledImage && state.uploadedImage) {
      const dimensionRatio = state.uploadedImage.width / upscaledImage.width;
      adjustedImageScale = state.imageScale * dimensionRatio;
      console.log('Scale adjustment:', {
        originalWidth: state.uploadedImage.width,
        upscaledWidth: upscaledImage.width,
        dimensionRatio: dimensionRatio,
        originalScale: state.imageScale,
        adjustedScale: adjustedImageScale
      });
    }
    
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(state.exportWidth/2, state.exportHeight/2, state.exportWidth/2, state.exportHeight/2, 0, 0, Math.PI * 2);
    ctx.clip();
    ctx.translate(state.imagePosition.x * scaleX, state.imagePosition.y * scaleY);
    ctx.rotate((state.imageRotation * Math.PI) / 180);
    if (state.flipHorizontal) ctx.scale(-1, 1);
    if (state.flipVertical) ctx.scale(1, -1);
    ctx.filter = `brightness(${state.brightness}%) contrast(${state.contrast}%) saturate(${state.saturation}%)`;
    const scaledWidth = imgToDraw.width * adjustedImageScale * scaleX;
    const scaledHeight = imgToDraw.height * adjustedImageScale * scaleY;
    ctx.drawImage(imgToDraw, -scaledWidth / 2, -scaledHeight / 2, scaledWidth, scaledHeight);
    ctx.restore();
  }

  function drawTextHighRes(ctx, textElement, scaleX, scaleY) {
    ctx.save();
    const fontFamily = textElement.font || 'Roboto';
    const scaledSize = textElement.size * Math.max(scaleX, scaleY);
    ctx.font = `${scaledSize}px '${fontFamily}', sans-serif`;
    ctx.fillStyle = textElement.color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    const lines = textElement.text.split('\n');
    const lineHeightPx = scaledSize * textElement.lineHeight;
    const totalHeight = lines.length * lineHeightPx;
    const startY = (textElement.y * scaleY) - totalHeight / 2 + lineHeightPx / 2;
    
    lines.forEach((line, index) => {
      const currentY = startY + (index * lineHeightPx);
      const scaledLetterSpacing = textElement.letterSpacing * scaleX;
      
      if (textElement.letterSpacing !== 0) {
        const letters = line.split('');
        let currentX = (textElement.x * scaleX) - (ctx.measureText(line).width / 2);
        letters.forEach(letter => {
          ctx.fillText(letter, currentX, currentY);
          currentX += ctx.measureText(letter).width + scaledLetterSpacing;
        });
      } else {
        if (textElement.outline) {
          ctx.strokeStyle = '#FFFFFF';
          ctx.lineWidth = 3 * Math.max(scaleX, scaleY);
          ctx.strokeText(line, textElement.x * scaleX, currentY);
        }
        if (textElement.gradient) {
          const gradient = ctx.createLinearGradient((textElement.x - 100) * scaleX, currentY, (textElement.x + 100) * scaleX, currentY);
          gradient.addColorStop(0, textElement.color);
          gradient.addColorStop(1, '#FFFFFF');
          ctx.fillStyle = gradient;
        }
        ctx.fillText(line, textElement.x * scaleX, currentY);
      }
    });
    ctx.restore();
  }

  function drawElementHighRes(ctx, element, scaleX, scaleY) {
    ctx.save();
    ctx.translate(element.x * scaleX, element.y * scaleY);
    ctx.rotate((element.rotation * Math.PI) / 180);
    ctx.fillStyle = element.color;
    const size = element.size * Math.max(scaleX, scaleY);
    
    switch(element.type) {
      case 'star':
      case 'star-filled':
        drawStar(ctx, 0, 0, 5, size, size/2);
        break;
      case 'heart':
        drawHeart(ctx, 0, 0, size);
        break;
      case 'circle':
        ctx.beginPath();
        ctx.arc(0, 0, size/2, 0, Math.PI * 2);
        ctx.fill();
        break;
      case 'square':
        ctx.fillRect(-size/2, -size/2, size, size);
        break;
      case 'triangle':
        drawTriangle(ctx, 0, 0, size);
        break;
      case 'arrow':
        drawArrow(ctx, 0, 0, size);
        break;
      case 'diamond':
        drawDiamond(ctx, 0, 0, size);
        break;
      case 'flag':
        drawFlag(ctx, 0, 0, size);
        break;
    }
    ctx.restore();
  }

  function drawSelectionUI(ctx, element) {
    ctx.save();
    ctx.strokeStyle = '#000DCA';
    ctx.lineWidth = 2;
    
    if (element.type === 'text') {
      const text = state.textElements[element.index];
      ctx.strokeRect(text.x - text.width/2, text.y - text.height/2, text.width, text.height);
    } else if (element.type === 'shape') {
      const shape = state.shapeElements[element.index];
      ctx.strokeRect(shape.x - shape.size/2, shape.y - shape.size/2, shape.size, shape.size);
    } else if (element.type === 'image' && state.uploadedImage) {
      const scaledWidth = state.uploadedImage.width * state.imageScale;
      const scaledHeight = state.uploadedImage.height * state.imageScale;
      ctx.strokeRect(state.imagePosition.x - scaledWidth/2, state.imagePosition.y - scaledHeight/2, scaledWidth, scaledHeight);
    }
    
    const handles = getResizeHandles(element);
    handles.forEach(handle => {
      ctx.fillStyle = '#FFFFFF';
      ctx.beginPath();
      ctx.arc(handle.x, handle.y, 8, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#000DCA';
      ctx.stroke();
    });
    
    const deletePos = getDeleteButtonPosition(element);
    if (deletePos) {
      ctx.fillStyle = '#CF0000';
      ctx.beginPath();
      ctx.arc(deletePos.x, deletePos.y, 12, 0, Math.PI * 2);
      ctx.fill();
      
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(deletePos.x - 5, deletePos.y - 5);
      ctx.lineTo(deletePos.x + 5, deletePos.y + 5);
      ctx.moveTo(deletePos.x + 5, deletePos.y - 5);
      ctx.lineTo(deletePos.x - 5, deletePos.y + 5);
      ctx.stroke();
    }
    
    ctx.restore();
  }

  function setupSaveButton() {
    const saveBtn = document.getElementById('saveDesignBtn');
    
    if (saveBtn) {
      saveBtn.addEventListener('click', function() {
        if (!state.uploadedImage && state.textElements.length === 0 && state.shapeElements.length === 0) {
          showMessage('Please add content to your design before saving', 'error');
          return;
        }

        state.selectedElement = null;
        renderCanvas();
        showMessage('Upscaling and generating high-resolution file...', 'info');

        if (state.uploadedImage && state.cloudinaryUrl) {
          const upscaledUrl = state.cloudinaryUrl.replace('/upload/', '/upload/e_upscale,q_auto:best,f_png/');
          const upscaledImg = new Image();
          upscaledImg.crossOrigin = 'anonymous';
          
          upscaledImg.onload = function() {
            console.log('Upscaled image loaded successfully:', upscaledImg.width, 'x', upscaledImg.height);
            renderHighResCanvas(upscaledImg);
            state.exportCanvas.toBlob(function(blob) {
              if (!blob) {
                showMessage('Error generating design file', 'error');
                return;
              }
              console.log('High-res export blob size:', Math.round(blob.size / 1024), 'KB');
              uploadHighResToCloudinary(blob);
            }, 'image/png', 1.0);
          };
          
          upscaledImg.onerror = function() {
            console.log('Upscale failed, trying alternative upscale method...');
            const alternativeUrl = state.cloudinaryUrl.replace('/upload/', '/upload/e_improve,q_auto:best,f_png/');
            const alternativeImg = new Image();
            alternativeImg.crossOrigin = 'anonymous';
            
            alternativeImg.onload = function() {
              console.log('Alternative upscale loaded successfully');
              renderHighResCanvas(alternativeImg);
              state.exportCanvas.toBlob(function(blob) {
                if (!blob) {
                  showMessage('Error generating design file', 'error');
                  return;
                }
                uploadHighResToCloudinary(blob);
              }, 'image/png', 1.0);
            };
            
            alternativeImg.onerror = function() {
              console.log('Alternative upscale also failed, using original image');
              showMessage('Using original image quality (upscale unavailable)', 'info');
              renderHighResCanvas();
              state.exportCanvas.toBlob(function(blob) {
                if (!blob) {
                  showMessage('Error generating design file', 'error');
                  return;
                }
                uploadHighResToCloudinary(blob);
              }, 'image/png', 1.0);
            };
            
            alternativeImg.src = alternativeUrl;
          };
          
          upscaledImg.src = upscaledUrl;
        } else {
          renderHighResCanvas();
          state.exportCanvas.toBlob(function(blob) {
            if (!blob) {
              showMessage('Error generating design file', 'error');
              return;
            }
            uploadHighResToCloudinary(blob);
          }, 'image/png', 1.0);
        }
      });
    }
  }

  function uploadHighResToCloudinary(blob) {
    showMessage('Uploading print-ready file...', 'info');
    const formData = new FormData();
    formData.append('file', blob, 'custom-design-highres.png');
    formData.append('upload_preset', window.cloudinaryConfig.uploadPreset);
    formData.append('folder', window.cloudinaryConfig.folder + '/print-ready');

    fetch(`https://api.cloudinary.com/v1_1/${window.cloudinaryConfig.cloudName}/image/upload`, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.secure_url) {
        console.log('High-res file uploaded:', data.secure_url);
        uploadPreviewToCloudinary(data.secure_url);
      } else {
        showMessage('Upload failed. Please try again.', 'error');
      }
    })
    .catch(error => {
      console.error('Upload error:', error);
      showMessage('Upload failed. Please try again.', 'error');
    });
  }

  function uploadPreviewToCloudinary(highResUrl) {
    state.renderingSafeZone = false;
    renderCanvas();
    
    state.canvas.toBlob(function(previewBlob) {
      state.renderingSafeZone = true;
      renderCanvas();
      
      const formData = new FormData();
      formData.append('file', previewBlob, 'custom-design-preview.jpg');
      formData.append('upload_preset', window.cloudinaryConfig.uploadPreset);
      formData.append('folder', window.cloudinaryConfig.folder + '/previews');

      fetch(`https://api.cloudinary.com/v1_1/${window.cloudinaryConfig.cloudName}/image/upload`, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if (data.secure_url) {
          console.log('Preview uploaded:', data.secure_url);
          addToCartWithDesign(highResUrl, data.secure_url);
        } else {
          showMessage('Upload failed. Please try again.', 'error');
        }
      })
      .catch(error => {
        console.error('Preview upload error:', error);
        showMessage('Upload failed. Please try again.', 'error');
      });
    }, 'image/jpeg', 0.85);
  }

  function addToCartWithDesign(highResUrl, previewUrl) {
    if (!state.productData.variantId) {
      tryToFindVariant();
    }
    if (!state.productData.variantId) {
      findVariantAndAddToCart(highResUrl, previewUrl);
    } else {
      addToCartWithVariant(state.productData.variantId, highResUrl, previewUrl);
    }
  }
  
  function findVariantAndAddToCart(highResUrl, previewUrl) {
    showMessage('Finding product variant...', 'info');
    
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = urlParams.get('return_url') || document.referrer;
    
    let productHandle = 'oval-stickers';
    
    if (returnUrl) {
      const match = returnUrl.match(/\/products\/([^?\/]+)/);
      if (match && match[1]) {
        productHandle = match[1];
      }
    }
    
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        if (product.variants && product.variants.length === 1) {
          state.productData.variantId = product.variants[0].id;
          addToCartWithVariant(state.productData.variantId, highResUrl, previewUrl);
          return;
        }
        
        if (product.variants && product.variants.length > 0) {
          state.productData.variantId = product.variants[0].id;
          addToCartWithVariant(state.productData.variantId, highResUrl, previewUrl);
        } else {
          showMessage('Could not find product variant. Please contact support.', 'error');
        }
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        showMessage('Error finding product. Please go back and try again.', 'error');
      });
  }
  
  function addToCartWithVariant(variantId, highResUrl, previewUrl) {
    const formattedSize = state.productData.size.replace('x', '"x') + '"';
    
    const formData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          'Custom Design': 'Yes',
          '_Design Preview': previewUrl,
          '_Print File': highResUrl,
          '_Design Specs': `${state.exportWidth}x${state.exportHeight}px (${formattedSize} at 300 DPI)`,
          'Product Details': (state.productData.quantity || 'Custom') + ' • ' + formattedSize,
          '_Has Text': state.textElements.length > 0 ? 'Yes' : 'No',
          '_Has Elements': state.shapeElements.length > 0 ? 'Yes' : 'No',
          '_Background Color': state.backgroundColor
        }
      }]
    };

    showMessage('Adding design to cart...', 'info');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Cart add failed with status: ' + response.status);
      }
      return response.json();
    })
    .then(data => {
      showMessage('✓ Added to cart! Redirecting...', 'success');
      
      setTimeout(function() {
        window.location.href = '/cart';
      }, 800);
    })
    .catch(error => {
      console.error('Cart error:', error);
      showMessage('Error adding to cart: ' + error.message, 'error');
    });
  }

  function setupResetButton() {
    const resetBtn = document.getElementById('resetAllBtn');
    
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        if (confirm('Are you sure you want to reset your design? This cannot be undone.')) {
          state.uploadedImage = null;
          state.uploadedImageUrl = null;
          state.cloudinaryUrl = null;
          state.imagePosition = { x: state.canvasWidth / 2, y: state.canvasHeight / 2 };
          state.imageScale = 1;
          state.imageRotation = 0;
          state.brightness = 100;
          state.contrast = 100;
          state.saturation = 100;
          state.flipHorizontal = false;
          state.flipVertical = false;
          state.backgroundColor = '#FFFFFF';
          state.textElements = [];
          state.shapeElements = [];
          state.selectedElement = null;
          state.currentTextInput = '';
          state.imageLayer = 1;

          document.getElementById('uploadedImageInfo').style.display = 'none';
          const previewOval = document.getElementById('previewOval');
          if (previewOval) previewOval.style.backgroundColor = '#FFFFFF';
          
          const fileInput = document.getElementById('fileInput');
          if (fileInput) fileInput.value = '';
          
          document.getElementById('textInput').value = '';
          document.getElementById('zoomSlider').value = 100;
          document.getElementById('zoomValue').textContent = '100%';
          document.getElementById('rotationSlider').value = 0;
          document.getElementById('rotationValue').textContent = '0°';
          document.getElementById('brightnessSlider').value = 100;
          document.getElementById('brightnessValue').textContent = '100%';
          document.getElementById('contrastSlider').value = 100;
          document.getElementById('contrastValue').textContent = '100%';
          document.getElementById('saturationSlider').value = 100;
          document.getElementById('saturationValue').textContent = '100%';

          renderCanvas();
          showMessage('Design reset successfully', 'success');
        }
      });
    }
  }

  function showMessage(message, type) {
    const existingToast = document.querySelector('.message-toast');
    if (existingToast) {
      existingToast.remove();
    }

    const toast = document.createElement('div');
    toast.className = `message-toast ${type}`;
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(() => {
      toast.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }

  window.customizerState = state;
  window.customizerRender = renderCanvas;

})();



// ============================================
// MOBILE SECTION - Toolbar and Panel Controls
// ============================================

(function() {
  'use strict';

  if (window.innerWidth > 768) return;
  
  const toolbarIcons = document.querySelectorAll('.mobile-toolbar-icon');
  const panels = document.querySelectorAll('.mobile-slide-panel');
  const overlay = document.querySelector('.mobile-panel-overlay');
  const closeButtons = document.querySelectorAll('.mobile-panel-close');

  let startY = 0;
  let currentY = 0;
  let isDragging = false;
  let activePanel = null;

  toolbarIcons.forEach(icon => {
    icon.addEventListener('click', function() {
      const panelId = this.getAttribute('data-panel');
      const panel = document.getElementById(panelId);
      
      panels.forEach(p => p.classList.remove('active'));
      toolbarIcons.forEach(i => i.classList.remove('active'));
      
      if (panel) {
        panel.classList.add('active');
        this.classList.add('active');
        overlay.classList.add('active');
        activePanel = panel;
        
        if (panelId === 'text-panel') {
          setTimeout(function() {
            const state = window.customizerState;
            if (state && state.textElements.length > 0) {
              state.selectedElement = { type: 'text', index: 0 };
              const mobileTextInput = document.getElementById('mobileTextInput');
              if (mobileTextInput) {
                mobileTextInput.value = state.textElements[0].text;
                mobileTextInput.focus();
              }
              if (window.customizerRender) {
                window.customizerRender();
              }
            }
          }, 200);
        }
      }
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', function() {
      closeAllPanels();
    });
  });

  if (overlay) {
    overlay.addEventListener('click', function() {
      closeAllPanels();
    });
  }

  const canvasWrapper = document.querySelector('.canvas-wrapper');
  if (canvasWrapper) {
    canvasWrapper.addEventListener('touchend', function(e) {
      if (activePanel && e.touches.length === 0) {
        closeAllPanels();
      }
    });
  }

  panels.forEach(panel => {
    const panelHeader = panel.querySelector('.mobile-panel-header');
    
    panelHeader.addEventListener('touchstart', function(e) {
      startY = e.touches[0].clientY;
      isDragging = true;
      panel.style.transition = 'none';
    });

    panelHeader.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      
      currentY = e.touches[0].clientY;
      const deltaY = currentY - startY;
      
      if (deltaY > 0) {
        panel.style.transform = `translateY(${deltaY}px)`;
      }
    });

    panelHeader.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      
      isDragging = false;
      panel.style.transition = 'transform 0.3s ease';
      
      const deltaY = currentY - startY;
      
      if (deltaY > 100) {
        closeAllPanels();
      } else {
        panel.style.transform = 'translateY(0)';
      }
    });
  });

  function closeAllPanels() {
    panels.forEach(p => {
      p.style.transition = 'transform 0.3s ease';
      p.style.transform = '';
      p.classList.remove('active');
    });
    toolbarIcons.forEach(i => i.classList.remove('active'));
    overlay.classList.remove('active');
    activePanel = null;
  }

})();

// ============================================
// MOBILE SECTION - Touch Interactions
// ============================================

(function() {
  'use strict';

  if (window.innerWidth > 768) return;

  setTimeout(function() {
    const canvas = document.getElementById('designCanvas');
    if (!canvas) return;

    const mobileUploadArea = document.getElementById('mobileUploadArea');
    const mobileFileInput = document.getElementById('mobileFileInput');
    
    if (mobileUploadArea && mobileFileInput) {
      mobileUploadArea.addEventListener('click', function() {
        mobileFileInput.click();
      });
      
      mobileFileInput.addEventListener('change', function(e) {
        if (e.target.files && e.target.files[0]) {
          const desktopFileInput = document.getElementById('fileInput');
          if (desktopFileInput) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(e.target.files[0]);
            desktopFileInput.files = dataTransfer.files;
            const event = new Event('change', { bubbles: true });
            desktopFileInput.dispatchEvent(event);
          }
        }
      });
    }

    const mobileTextInput = document.getElementById('mobileTextInput');
    const desktopTextInput = document.getElementById('textInput');
    
    if (mobileTextInput && desktopTextInput) {
      mobileTextInput.addEventListener('input', function() {
        const state = window.customizerState;
        if (state && state.textElements.length > 0 && 
            (!state.selectedElement || state.selectedElement.type !== 'text')) {
          state.selectedElement = { type: 'text', index: 0 };
        }
        desktopTextInput.value = this.value;
        desktopTextInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
      
      setInterval(function() {
        if (desktopTextInput.value !== mobileTextInput.value) {
          mobileTextInput.value = desktopTextInput.value;
        }
      }, 500);
    }

    const mobileBackgroundGrid = document.getElementById('mobileBackgroundColorGrid');
    if (mobileBackgroundGrid) {
      const swatches = mobileBackgroundGrid.querySelectorAll('.color-swatch');
      swatches.forEach(swatch => {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const color = this.getAttribute('data-color');
          const desktopGrid = document.getElementById('backgroundColorGrid');
          if (desktopGrid && color) {
            const desktopSwatch = desktopGrid.querySelector(`[data-color="${color}"]`);
            if (desktopSwatch) desktopSwatch.click();
          }
          swatches.forEach(s => s.classList.remove('selected'));
          this.classList.add('selected');
        });
      });
    }

    const mobileTextColorGrid = document.getElementById('mobileTextColorGrid');
    if (mobileTextColorGrid) {
      const swatches = mobileTextColorGrid.querySelectorAll('.color-swatch');
      swatches.forEach(swatch => {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const color = this.getAttribute('data-color');
          const state = window.customizerState;
          if (state && !state.selectedElement && state.textElements.length > 0) {
            state.selectedElement = { type: 'text', index: 0 };
            if (window.customizerRender) window.customizerRender();
          }
          setTimeout(function() {
            const desktopGrid = document.getElementById('textColorGrid');
            if (desktopGrid && color) {
              const desktopSwatch = desktopGrid.querySelector(`[data-color="${color}"]`);
              if (desktopSwatch) desktopSwatch.click();
            }
          }, 50);
          swatches.forEach(s => s.classList.remove('selected'));
          this.classList.add('selected');
        });
      });
    }

    function setupMobileSlider(mobileId, desktopId, valueId) {
      const mobileSlider = document.getElementById(mobileId);
      const desktopSlider = document.getElementById(desktopId);
      const valueDisplay = document.getElementById(valueId);
      
      if (mobileSlider && desktopSlider) {
        mobileSlider.addEventListener('input', function() {
          desktopSlider.value = this.value;
          const inputEvent = new Event('input', { bubbles: true });
          desktopSlider.dispatchEvent(inputEvent);
          const changeEvent = new Event('change', { bubbles: true });
          desktopSlider.dispatchEvent(changeEvent);
          if (valueDisplay) {
            setTimeout(function() {
              const desktopValueId = valueId.replace('mobile', '').charAt(0).toLowerCase() + valueId.replace('mobile', '').slice(1);
              const desktopValue = document.getElementById(desktopValueId);
              if (desktopValue) {
                valueDisplay.textContent = desktopValue.textContent;
              }
            }, 50);
          }
        });
      }
    }

    setupMobileSlider('mobileZoomSlider', 'zoomSlider', 'mobileZoomValue');
    setupMobileSlider('mobileRotationSlider', 'rotationSlider', 'mobileRotationValue');
    setupMobileSlider('mobileBrightnessSlider', 'brightnessSlider', 'mobileBrightnessValue');
    setupMobileSlider('mobileContrastSlider', 'contrastSlider', 'mobileContrastValue');
    setupMobileSlider('mobileSaturationSlider', 'saturationSlider', 'mobileSaturationValue');
    setupMobileSlider('mobileFontSizeSlider', 'fontSizeSlider', 'mobileFontSizeValue');
    setupMobileSlider('mobileLetterSpacingSlider', 'letterSpacingSlider', 'mobileLetterSpacingValue');
    setupMobileSlider('mobileLineHeightSlider', 'lineHeightSlider', 'mobileLineHeightValue');

    const mobileFontSelected = document.getElementById('mobileFontSelected');
    const mobileFontOptions = document.getElementById('mobileFontOptions');
    
    if (mobileFontSelected && mobileFontOptions) {
      mobileFontSelected.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        mobileFontOptions.classList.toggle('open');
        mobileFontSelected.classList.toggle('open');
      });

      const fontOptions = mobileFontOptions.querySelectorAll('.font-option');
      fontOptions.forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const fontName = this.getAttribute('data-font');
          const state = window.customizerState;
          if (state && !state.selectedElement && state.textElements.length > 0) {
            state.selectedElement = { type: 'text', index: 0 };
            if (window.customizerRender) window.customizerRender();
          }
          setTimeout(function() {
            const desktopOptions = document.getElementById('fontOptions');
            if (desktopOptions) {
              const desktopOption = desktopOptions.querySelector(`[data-font="${fontName}"]`);
              if (desktopOption) desktopOption.click();
            }
          }, 50);
          mobileFontSelected.textContent = fontName;
          mobileFontSelected.style.fontFamily = this.style.fontFamily;
          fontOptions.forEach(o => o.classList.remove('selected'));
          this.classList.add('selected');
          mobileFontOptions.classList.remove('open');
          mobileFontSelected.classList.remove('open');
        });
      });

      document.addEventListener('click', function(e) {
        if (!e.target.closest('.font-dropdown-custom')) {
          mobileFontOptions.classList.remove('open');
          mobileFontSelected.classList.remove('open');
        }
      });
    }

    function setupMobileButton(mobileId, desktopId) {
      const mobileBtn = document.getElementById(mobileId);
      const desktopBtn = document.getElementById(desktopId);
      if (mobileBtn && desktopBtn) {
        mobileBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          desktopBtn.click();
        });
      }
    }

    setupMobileButton('mobileFlipHorizontalBtn', 'flipHorizontalBtn');
    setupMobileButton('mobileFlipVerticalBtn', 'flipVerticalBtn');
    setupMobileButton('mobileImageFrontBtn', 'imageFrontBtn');
    setupMobileButton('mobileImageBackBtn', 'imageBackBtn');
    setupMobileButton('mobileTextOutlineBtn', 'textOutlineBtn');
    setupMobileButton('mobileTextGradientBtn', 'textGradientBtn');
    setupMobileButton('mobileTextFrontBtn', 'textFrontBtn');
    setupMobileButton('mobileTextBackBtn', 'textBackBtn');
    setupMobileButton('mobileBringToFrontBtn', 'bringToFrontBtn');
    setupMobileButton('mobileSendToBackBtn', 'sendToBackBtn');
    setupMobileButton('mobileClearElementsBtn', 'clearElementsBtn');
    setupMobileButton('mobileResetBackgroundBtn', 'resetBackgroundBtn');

  }, 500);

})();

// ============================================
// MOBILE SECTION - Touch Editing Controls (Two-Finger Pinch)
// ============================================

(function() {
  'use strict';

  if (window.innerWidth > 768) return;

  setTimeout(function() {
    const canvas = document.getElementById('designCanvas');
    if (!canvas) return;

    console.log('Mobile pinch-to-resize initializing...');

    let pinchState = {
      active: false,
      startDistance: 0,
      initialSize: 0,
      selectedElement: null
    };

    let firstTouchPos = null;
    let firstTouchTime = 0;
    let isDraggingMobile = false;
    let dragOffset = { x: 0, y: 0 };

    function getTouchPos(touch) {
      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;
      return {
        x: (touch.clientX - rect.left) * scaleX,
        y: (touch.clientY - rect.top) * scaleY
      };
    }

    function getDistance(touch1, touch2) {
      const pos1 = getTouchPos(touch1);
      const pos2 = getTouchPos(touch2);
      return Math.sqrt(Math.pow(pos2.x - pos1.x, 2) + Math.pow(pos2.y - pos1.y, 2));
    }

    function findElementAtPosition(x, y) {
      const state = window.customizerState;
      if (!state) return null;

      const foundElements = [];

      for (let i = 0; i < state.textElements.length; i++) {
        const text = state.textElements[i];
        const halfW = text.width / 2;
        const halfH = text.height / 2;
        if (x >= text.x - halfW && x <= text.x + halfW &&
            y >= text.y - halfH && y <= text.y + halfH) {
          foundElements.push({ type: 'text', index: i, layer: text.layer || 0 });
        }
      }

      for (let i = 0; i < state.shapeElements.length; i++) {
        const shape = state.shapeElements[i];
        const dist = Math.sqrt(Math.pow(x - shape.x, 2) + Math.pow(y - shape.y, 2));
        if (dist <= shape.size / 2) {
          foundElements.push({ type: 'shape', index: i, layer: shape.layer || 0 });
        }
      }

      if (state.uploadedImage) {
        const scaledWidth = state.uploadedImage.width * state.imageScale;
        const scaledHeight = state.uploadedImage.height * state.imageScale;
        const halfW = scaledWidth / 2;
        const halfH = scaledHeight / 2;
        if (x >= state.imagePosition.x - halfW && x <= state.imagePosition.x + halfW &&
            y >= state.imagePosition.y - halfH && y <= state.imagePosition.y + halfH) {
          foundElements.push({ type: 'image', index: 0, layer: state.imageLayer || 1 });
        }
      }

      if (foundElements.length === 0) return null;

      foundElements.sort((a, b) => b.layer - a.layer);
      return foundElements[0];
    }

    canvas.addEventListener('touchstart', function(e) {
      const state = window.customizerState;
      if (!state) return;

      // FIRST FINGER DOWN
      if (e.touches.length === 1) {
        firstTouchPos = getTouchPos(e.touches[0]);
        firstTouchTime = Date.now();
        isDraggingMobile = false;
        
        // Calculate drag offset if something is selected
        if (state.selectedElement) {
          if (state.selectedElement.type === 'text') {
            const text = state.textElements[state.selectedElement.index];
            dragOffset.x = firstTouchPos.x - text.x;
            dragOffset.y = firstTouchPos.y - text.y;
          } else if (state.selectedElement.type === 'shape') {
            const shape = state.shapeElements[state.selectedElement.index];
            dragOffset.x = firstTouchPos.x - shape.x;
            dragOffset.y = firstTouchPos.y - shape.y;
          } else if (state.selectedElement.type === 'image') {
            dragOffset.x = firstTouchPos.x - state.imagePosition.x;
            dragOffset.y = firstTouchPos.y - state.imagePosition.y;
          }
          
          e.preventDefault();
          e.stopPropagation();
        }
        return;
      }
      
      // SECOND FINGER DOWN - start pinch
      if (e.touches.length === 2) {
        e.preventDefault();
        e.stopPropagation();
        
        firstTouchPos = null;
        firstTouchTime = 0;
        isDraggingMobile = false;
        
        if (!state.selectedElement) return;

        pinchState.active = true;
        pinchState.startDistance = getDistance(e.touches[0], e.touches[1]);
        pinchState.selectedElement = state.selectedElement;

        if (state.selectedElement.type === 'text') {
          pinchState.initialSize = state.textElements[state.selectedElement.index].size;
        } else if (state.selectedElement.type === 'shape') {
          pinchState.initialSize = state.shapeElements[state.selectedElement.index].size;
        } else if (state.selectedElement.type === 'image') {
          pinchState.initialSize = state.imageScale;
        }

        console.log('Pinch started on selected', state.selectedElement.type);
      }
    }, true);

    canvas.addEventListener('touchmove', function(e) {
      const state = window.customizerState;
      if (!state) return;

      // TWO FINGER PINCH
      if (e.touches.length === 2 && pinchState.active) {
        e.preventDefault();
        e.stopPropagation();
        
        const currentDistance = getDistance(e.touches[0], e.touches[1]);
        const scaleFactor = currentDistance / pinchState.startDistance;
        const element = pinchState.selectedElement;
        
        if (element.type === 'text') {
          const newSize = Math.max(12, Math.min(200, pinchState.initialSize * scaleFactor));
          state.textElements[element.index].size = newSize;
          
        } else if (element.type === 'shape') {
          const newSize = Math.max(20, Math.min(300, pinchState.initialSize * scaleFactor));
          state.shapeElements[element.index].size = newSize;
          
        } else if (element.type === 'image') {
          const newScale = Math.max(0.1, Math.min(5, pinchState.initialSize * scaleFactor));
          state.imageScale = newScale;
        }

        if (window.customizerRender) {
          window.customizerRender();
        }
        return;
      }

      // SINGLE FINGER DRAG
      if (e.touches.length === 1 && firstTouchPos && state.selectedElement) {
        const currentPos = getTouchPos(e.touches[0]);
        const distance = Math.sqrt(
          Math.pow(currentPos.x - firstTouchPos.x, 2) + 
          Math.pow(currentPos.y - firstTouchPos.y, 2)
        );

        // If moved more than 10 pixels, it's a drag
        if (distance > 10) {
          e.preventDefault();
          e.stopPropagation();
          
          isDraggingMobile = true;
          
          const newX = currentPos.x - dragOffset.x;
          const newY = currentPos.y - dragOffset.y;
          
          if (state.selectedElement.type === 'text') {
            state.textElements[state.selectedElement.index].x = newX;
            state.textElements[state.selectedElement.index].y = newY;
          } else if (state.selectedElement.type === 'shape') {
            state.shapeElements[state.selectedElement.index].x = newX;
            state.shapeElements[state.selectedElement.index].y = newY;
          } else if (state.selectedElement.type === 'image') {
            state.imagePosition.x = newX;
            state.imagePosition.y = newY;
          }

          if (window.customizerRender) {
            window.customizerRender();
          }
        }
      }
    }, true);

    canvas.addEventListener('touchend', function(e) {
      const state = window.customizerState;
      if (!state) return;
      
      if (pinchState.active) {
        e.preventDefault();
        e.stopPropagation();
        pinchState.active = false;
        console.log('Pinch ended');
      }
      
      // All fingers lifted - check if this was a tap (not a drag)
      if (e.touches.length === 0 && firstTouchPos !== null && !isDraggingMobile) {
        const tapDuration = Date.now() - firstTouchTime;
        
        // Quick tap without dragging = selection
        if (tapDuration < 300) {
          const element = findElementAtPosition(firstTouchPos.x, firstTouchPos.y);
          
          if (element) {
            e.preventDefault();
            e.stopPropagation();
            
            state.selectedElement = element;
            
            if (element.type === 'text') {
              const text = state.textElements[element.index];
              const mobileTextInput = document.getElementById('mobileTextInput');
              if (mobileTextInput) {
                mobileTextInput.value = text.text;
              }
            }
            
            if (window.customizerRender) {
              window.customizerRender();
            }
            console.log('Selected:', element.type);
          } else {
            state.selectedElement = null;
            if (window.customizerRender) {
              window.customizerRender();
            }
          }
        }
      }
      
      firstTouchPos = null;
      firstTouchTime = 0;
      isDraggingMobile = false;
    }, true);

    console.log('Mobile pinch-to-resize ready');

  }, 1500);
  
  // MOBILE KEYBOARD PROTECTION - Prevent element deletion while typing
  const mobileTextInput = document.getElementById('mobileTextInput');
  if (mobileTextInput) {
    mobileTextInput.addEventListener('keydown', function(e) {
      if (e.key === 'Delete' || e.key === 'Backspace') {
        e.stopPropagation();
      }
    }, true);
    
    console.log('Mobile keyboard protection active');
  }

  // MOBILE FLOATING DELETE BUTTON
  const deleteBtn = document.getElementById('mobileFloatingDelete');
  if (deleteBtn) {
    setInterval(function() {
      const state = window.customizerState;
      if (state && state.selectedElement) {
        deleteBtn.style.display = 'block';
      } else {
        deleteBtn.style.display = 'none';
      }
    }, 200);

    deleteBtn.addEventListener('click', function() {
      const state = window.customizerState;
      if (!state || !state.selectedElement) return;
      
      if (state.selectedElement.type === 'text') {
        state.textElements.splice(state.selectedElement.index, 1);
        const mobileTextInput = document.getElementById('mobileTextInput');
        if (mobileTextInput) mobileTextInput.value = '';
      } else if (state.selectedElement.type === 'shape') {
        state.shapeElements.splice(state.selectedElement.index, 1);
      } else if (state.selectedElement.type === 'image') {
        const desktopRemoveBtn = document.getElementById('removeImageBtn');
        if (desktopRemoveBtn) desktopRemoveBtn.click();
      }
      
      state.selectedElement = null;
      if (window.customizerRender) window.customizerRender();
    });
    
    console.log('Mobile floating delete button ready');
  }

})();